export default __webpack_public_path__ + "static/media/90bf153b7743ba8d.f22b5dd7f5260d7ddfc015ae9f36f57f.svg";